// const API_BASE_URL = "http://localhost/El_Codamics/git/whatsapp/Whatsapp-API-Management/src/api";
const API_BASE_URL = "https://whatsapp.elcodamics.com/api";


const apiEndpoints = {
  addContact: `${API_BASE_URL}/add_contact.php`,
  language: `${API_BASE_URL}/language.php`,
  Category: `${API_BASE_URL}/category.php`,
  customer_profile: `${API_BASE_URL}/customer_profile.php`,
  transaction: `${API_BASE_URL}/add_transaction.php`,
  getProfile: `${API_BASE_URL}/register.php`,
  addtransaction: `${API_BASE_URL}/add_transaction.php`,
  getGroups: `${API_BASE_URL}/get_groups.php`,
  managetemplate: `${API_BASE_URL}/managetemplate.php`,
  whatsappLog: `${API_BASE_URL}/whatsapp_log.php`,
  fetchTemplate: `${API_BASE_URL}/fetchtemplate.php`,
  apiurl: `${API_BASE_URL}/api_settings.php`,
  fetchmessage: `${API_BASE_URL}/message_crud.php`,
  metaTemplates: `${API_BASE_URL}/meta_templates.php`,
  Reports: `${API_BASE_URL}/reports.php`,
  dashboard: `${API_BASE_URL}/dashboard.php`,
  sendmessage: `${API_BASE_URL}/send_message.php`,
  flow: `${API_BASE_URL}/flow.php`,
  chat_history: `${API_BASE_URL}/chat_history.php`,
  chat_messages: `${API_BASE_URL}/chat_messages.php`,
  getSupportDetails: `${API_BASE_URL}/support.php`,
  announcements: `${API_BASE_URL}/announcement.php`,
  send_session_message: `${API_BASE_URL}/send_session_message.php`,
};

export default apiEndpoints;
